module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/seven-by-five-c5a57cb11b968afcfbab228a8f451272.png";